import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import { QuestionAddress } from "@/components/features/items/edit/_shared/ui/components/main/questions/address/address/address";

import type { HotelSettingsHotelInfoI18nFormModelMethodsType } from "../../../../model/usecase/use-create-form-model/methods";

type Props = {
	addressMethods: HotelSettingsHotelInfoI18nFormModelMethodsType["addressMethods"];
};

export const HotelSettingsHotelInfoI18nDetailedInfoSettingsIsland = ({ addressMethods }: Props) => {
	return (
		<FeatureIslandMainWithBackGround islandTitle="詳細情報設定">
			<QuestionAddress
				hasFeatureIslandCategoryContext={false}
				required={true}
				title="施設の住所"
				guide=""
				isEdited={addressMethods.isEdited}
				hasError={addressMethods.hasError}
				address={addressMethods.address}
				onSetPref={addressMethods.onSetPref}
				onSetCity={addressMethods.onSetCity}
				onSetTown={addressMethods.onSetTown}
				onSetPostalCode={addressMethods.onSetPostalCode}
			/>
		</FeatureIslandMainWithBackGround>
	);
};

HotelSettingsHotelInfoI18nDetailedInfoSettingsIsland.displayName =
	"HotelSettingsHotelInfoI18nDetailedInfoSettingsIsland";
